import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { ChevronRight, Clock, Activity, Building } from 'lucide-react';
import {
  getClassificationBadge, getRiskBadge, getDealHealthColor,
  getWinProbability, formatDate, formatDuration
} from './utils';

/**
 * Single call card in the Calls tab.
 */
export default function CallCard({ call }) {
  const navigate = useNavigate();
  const grade = call.grade || call.classification;
  const health = call.grade || call.deal_health;
  const wp = getWinProbability(call.final_deal_score);

  return (
    <Card
      className="bg-card border-border/50 hover:border-primary/30 transition-colors cursor-pointer group"
      onClick={() => navigate(`/report/${call.call_id}`)}
      data-testid={`call-card-${call.call_id}`}
    >
      <CardContent className="p-5">
        <div className="flex items-start justify-between gap-4">
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-3 mb-2 flex-wrap">
              <h3 className="font-heading text-lg font-semibold text-foreground truncate">
                {call.title}
              </h3>
              <Badge className={getClassificationBadge(grade)}>{grade}</Badge>
              <Badge className={getRiskBadge(call.risk_status)}>{call.risk_status} Risk</Badge>
            </div>

            <div className="flex items-center gap-4 text-sm text-muted-foreground flex-wrap">
              {call.company_name && (
                <span className="flex items-center gap-1">
                  <Building className="w-4 h-4" />
                  {call.company_name}
                </span>
              )}
              <span className="flex items-center gap-1">
                <Clock className="w-4 h-4" />
                {formatDate(call.call_date || call.created_at)}
              </span>
              {call.duration_seconds > 0 && (
                <span className="flex items-center gap-1">
                  <Activity className="w-4 h-4" />
                  {formatDuration(call.duration_seconds)}
                </span>
              )}
              <span className={`capitalize ${getDealHealthColor(health)}`}>
                {health}
              </span>
            </div>
          </div>

          <div className="flex items-center gap-4">
            {call.status === 'completed' && (
              <div className="text-right">
                <p className="text-xs text-muted-foreground">Win Prob.</p>
                <p className={`font-heading text-2xl font-bold ${wp.color}`}>{wp.pct}%</p>
              </div>
            )}
            <ChevronRight className="w-5 h-5 text-muted-foreground group-hover:text-primary transition-colors" />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
